// const moment = require('moment');
// import { gsap } from "gsap";
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { Navigation, Pagination, Autoplay, EffectFade, Swiper } from 'swiper'
// Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
// gsap.registerPlugin(ScrollTrigger);
import Splide from '@splidejs/splide';

export function index() {
	if (document.querySelector('.p-home')) {

		document.addEventListener('DOMContentLoaded', function () {
			const splidelinks = new Splide('.p-home__links', {

				type: 'loop',
				autoWidth: true,
				autoplay: true,
				focus: 'center',
				arrows: false,
				pagination: false,
				gap: '20px'
			});
			splidelinks.mount();
		});


		const splidemv = new Splide('.p-home__mv .splide', {

			type: 'fade',
			speed: 1000,
			interval: 8000,
			autoplay: true,
			arrows: false,
			pagination: false,
			rewind: true,
			drag: false
		});
		splidemv.mount();


		document.querySelector('.text__type1').style.opacity = 1;
		splidemv.on('moved', function (newIndex, prevIndex, destIndex) {
			console.log(newIndex, prevIndex, destIndex);
			if (newIndex >= 2) {
				document.querySelector('.text__type1').style.opacity = 0;
				document.querySelector('.text__type2').style.opacity = 1;
			} else {
				document.querySelector('.text__type2').style.opacity = 0;
				document.querySelector('.text__type1').style.opacity = 1;
			}
		});
	}
}
